import { Trans, useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useSubscription } from 'services/hooks';
import userApi from 'services/api/user';
import { StyledDescription, StyledHeader } from './styled';

const AccountLimitsHeader = () => {
  const { t } = useTranslation();
  const { isFreeAccount } = useSubscription();

  const { data, isLoading, isError } = userApi.useGetAccountLimitsQuery();

  if (isError) {
    return <Box>{t('account:subscription:resetDateError')}</Box>;
  }

  return (
    <Box>
      <StyledHeader>{t('account:subscription:accountLimits')}</StyledHeader>
      {!isFreeAccount && (
        <StyledDescription>
          {t('account:subscription:allowancesReset')}
          {isLoading ? (
            'dd/mm/yyyy'
          ) : (
            <Trans i18nKey="account:subscription:subscriptionEnd">
              {data?.resetData.nextResetDate
                ? new Date(data.resetData.nextResetDate).toLocaleDateString()
                : ' '}
            </Trans>
          )}
        </StyledDescription>
      )}
    </Box>
  );
};

export default AccountLimitsHeader;
